import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Checkbox, CircularProgress, FormControl, InputLabel, MenuItem, Select, InputAdornment} from "@material-ui/core";
import axios from 'axios';
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import {ServiceLocator} from "../../Services/ServiceLocator";
import { v4 as uuid } from 'uuid';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from "dayjs";
import WorkshopTemplate from "./WorkshopTemplate";
import {FilePond} from "react-filepond";
import { DatePicker } from "@material-ui/pickers";
import { format } from 'date-fns';
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../utils/numberInputUtils';

import { AuthenticationService } from "../../Services/AuthenticationService";
let part = null;

class Purchase extends React.Component {
    state = {
        loading: true,
        savingLog: false,
        quantity: 0,
        newLogIsPaid: false,
        newLogIsReceived: false,
        newLogReceivedDate: dayjs(new Date().toDateString()),
        newLogOrderDate: dayjs(new Date().toDateString()),
        newLogCompany: '',
        invoiceFiles: [],
        packingSlipFiles: [],
        newLogPricePaid: 0.00,
        newLogQuantityReceived: ''
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;

        self.setState({loading: true});
        const partId = globalProps.match.params.partId;
        Promise.all([self.loadParts(), self.loadPart(partId)]).then(() => {
            self.setState({part, loading: false});
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((parts) => {
            self.setState({parts});
        });
    };

    loadPart = (partId) => {
        const partService = ServiceLocator.Instance.getPartService();

        return this.loadVendors().then(() => {
            return partService.getById(partId).then((partResult) => {
                part = partResult;
                part.vendorParts.forEach((vendorPart) => {
                    vendorPart.vendorName = this.state.vendors.find(x => x.id === vendorPart.vendorId).name;
                });
                part.vendorsList = part.vendorParts.map((vendor) => vendor.vendorName);
            }).catch(() => {
                part = null;
            });
        })
    };

    loadVendors = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllVendors().then((vendors) => {
            this.setState({vendors});
        })
    };

    changeCompany = (vendor) => {
        this.setState({newLogCompany: vendor, customVendor: vendor === "Other..."});
    };

    changeCustomCompany = (vendor) => {
        this.setState({newLogCompany: vendor});
    };

    addPurchaseOrder = () => {
        const self = this;
        self.setState({savingPurchaseLog: true});

        const orderId = uuid();

        const partId = globalProps.match.params.partId;
        const newLogParts = [{
            id: uuid(),
            companyName: this.state.newLogCompany,
            quantity: parseNumberInputValue(this.state.quantity),
            quantityReceived: parseNumberInputValue(this.state.newLogQuantityReceived),
            partId: partId,
            isPaid: this.state.newLogIsPaid,
            pricePaid: this.state.newLogIsPaid ? parseNumberInputValue(this.state.newLogPricePaid) : 0.00,
            orderDate: this.state.newLogOrderDate,
            orderId: orderId,
            receivedDate: this.state.newLogIsReceived ? this.state.newLogReceivedDate : null
        }];

        const payload = {
            id: orderId,
            placedOn: this.state.newLogOrderDate,
            pricePaid: this.state.newLogIsPaid ? parseNumberInputValue(this.state.newLogPricePaid) : 0.00,
            invoices: [],
            packingSlips: [],
            purchasedParts: newLogParts
        };

        const partService = ServiceLocator.Instance.getPartService();
        partService.createPurchaseOrder(payload).then((purchaseOrder) => {
            this.setState({selectedPurchaseOrderId: purchaseOrder.id});
            Promise.all([self.saveInvoiceFiles(), self.savePackingSlipFiles()]).then(() => {
                window.$alertSuccess("Purchase log created");
                self.setState({addingPurchaseLogOpen: false, savingPurchaseLog: false});
                self.loadData();
            });
        });
    };

    saveInvoiceFiles = () => {
        // Note: Invoice attachment is now handled at the line-item level in the Purchases interface
        // This workshop interface no longer supports direct invoice upload
        return Promise.resolve();
    };

    savePackingSlipFiles = () => {
        const self = this;
        if (this.state.packingSlipFiles.length > 0) {
            self.setState({savingPurchaseOrder: true});
            const partService = ServiceLocator.Instance.getPartService();
            
            // Create the packing slip data
            const packingSlipData = {
                purchaseOrderFk: this.state.selectedPurchaseOrderId,
                dateReceived: new Date().toISOString(),
                items: this.state.packingSlipItems || []
            };

            // For now, we'll just use the first file
            const file = this.state.packingSlipFiles[0];
            
            return partService.createPurchaseOrderPackingSlip(packingSlipData, file).then((newPackingSlip) => {
                window.$alertSuccess("Packing slip uploaded.");
                self.setState({savingPurchaseOrder: false, packingSlipFiles: [], packingSlipItems: []});
                self.loadData();
            }).catch(function (error) {
                window.$alertError("Something went wrong saving your packing slip.");
                console.log(error);
                self.setState({savingPurchaseOrder: false});
            });
        } else return Promise.resolve();
    };

    updateQuantity = (newQuantity) => {
        const partExpanded = this.state.parts.find(x => x.part.id === this.state.part.id);
        let unitCost = partExpanded ? partExpanded.cost : 0.00;
        let pricePaid = (newQuantity * unitCost).toFixed(2);
        this.setState({quantity: newQuantity, newLogPricePaid: pricePaid});
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <CircularProgress/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const {part} = self.state;

        if (this.state.completed) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Log complete!</h2>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={() => globalProps.history.push(`/search/${part.id}`)}
                            className="success-button-lg"
                        >
                            Part Home
                        </Button>
                        <br/><br/>
                    </div>
                </WorkshopTemplate>
            );
        }

        if (!part) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Invalid URL</h2>
                    </div>
                </WorkshopTemplate>
            );
        }

        return (
            <WorkshopTemplate>
                <div className="mobile-container">
                    {part ?
                        <div>
                            <Button 
                                variant="contained"
                                color="primary"
                                onClick={() => globalProps.history.push(`/search/${part.id}`)}
                                className="success-button-lg"
                            >
                                Part Home
                            </Button>
                            <h2>Purchase Log<br/>{part.partId} rev {part.revision}</h2>
                        </div>
                        : ""}
                    <div style={{marginBottom: 20}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                label="Order Date"
                                value={this.state.newLogOrderDate}
                                onChange={(newValue) => this.setState({newLogOrderDate: newValue})}
                                renderInput={(params) => <TextField {...params} variant="outlined" />}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    {part && part.vendorsList.length > 0 ?
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="cost-type-select-label">Vendor</InputLabel>
                            <Select
                                value={this.state.newLogCompany}
                                style={{width: '100%', marginBottom: 20, textAlign: 'left'}}
                                label="Vendor"
                            >
                                {part.vendorsList.map((vendor) => {
                                    return (
                                        <MenuItem value={vendor}
                                                  onClick={() => this.changeCompany(vendor)}>{vendor}</MenuItem>
                                    )
                                })}
                                <MenuItem value={"Other..."}
                                          onClick={() => this.changeCompany("Other...")}>{"Other..."}</MenuItem>
                            </Select>
                        </FormControl>
                        : ""}
                    {this.state.customVendor || (part && part.vendorsList.length === 0) ?
                        <TextField onChange={(event) => this.changeCustomCompany(event.target.value)} label={"Vendor"}
                                   variant="outlined"
                                   style={{width: '100%', marginBottom: 20}}
                                   autoComplete="off"/>
                        : ""}
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {
                            this.updateQuantity(Number.parseInt(this.state.quantity) + 1)
                        }}
                    >
                        1
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {
                            this.updateQuantity(Number.parseInt(this.state.quantity) + 2)
                        }}
                    >
                        2
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {
                            this.updateQuantity(Number.parseInt(this.state.quantity) + 4)
                        }}
                    >
                        4
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {
                            this.updateQuantity(Number.parseInt(this.state.quantity) + 10)
                        }}
                    >
                        10
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {
                            this.updateQuantity(Number.parseInt(this.state.quantity) + 20)
                        }}
                    >
                        20
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {
                            this.updateQuantity(Number.parseInt(this.state.quantity) + 100)
                        }}
                    >
                        100
                    </Button>
                    <br/><br/>
                    <TextField
                        placeholder="Quantity Ordered"
                        label="Quantity Ordered"
                        variant="outlined" inputProps={{inputMode: 'numeric'}}
                        onChange={(event) =>
                            this.updateQuantity(parseNumberInputValue(event.target.value))}
                        value={this.state.quantity}
                        autoComplete="off"
                    />
                    <br/><br/>
                    <Checkbox onClick={(event) => {
                        this.setState({newLogIsPaid: event.target.checked})
                    }} checked={this.state.newLogIsPaid}/> Is Paid
                    <br/>
                    {this.state.newLogIsPaid === true ?
                        <div style={{marginBottom: 20, marginTop: 10}}>
                            <TextField value={this.state.newLogPricePaid || ''}
                                       onChange={(event) => this.setState({newLogPricePaid: event.target.value})}
                                       label={"Price Paid"}
                                       variant="outlined"
                                       style={{width: '100%', marginBottom: 20}}
                                       InputProps={{
                                           startAdornment: <InputAdornment position="start">$</InputAdornment>
                                       }}
                                       autoComplete="off"/>
                        </div>
                        : ""}
                    <Checkbox onClick={(event) => {
                        this.setState({newLogIsReceived: event.target.checked})
                    }} checked={this.state.newLogIsReceived}/> Is Received
                    <br/>
                    {this.state.newLogIsReceived === true ?
                        <div style={{marginBottom: 20, marginTop: 10}}>
                            <TextField value={this.state.newLogQuantityReceived || ''}
                                       onChange={(event) => this.setState({newLogQuantityReceived: event.target.value})}
                                       label={"Quantity Received"}
                                       variant="outlined"
                                       style={{width: '100%', marginBottom: 20}}
                                       autoComplete="off"/>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    label="Received Date"
                                    value={this.state.newLogReceivedDate}
                                    onChange={(newValue) => this.setState({newLogReceivedDate: newValue})}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        : ""}
                    <h3>Upload invoices</h3>
                    <FilePond
                        allowMultiple={true}
                        allowFileSizeValidation={true}
                        maxFileSize={'50MB'}
                        allowFileTypeValidation={true}
                        acceptedFileTypes={['image/*', 'audio/*', 'video/*', 'application/vnd.ms-excel',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                            'application/pdf']}
                        fileValidateTypeLabelExpectedTypes={'Supported types are image, audio, video, office documents, or pdf.'}
                        fileValidateTypeDetectType={(source, type) => new Promise((resolve, reject) => {
                            // Do custom type detection here and return with promise
                            return resolve(type);
                        })}
                        files={this.state.invoiceFiles}
                        onupdatefiles={fileItems => {
                            this.setState({
                                invoiceFiles: fileItems.map(fileItem => fileItem.file)
                            });
                        }}
                    />
                    <h3>Upload packing slips</h3>
                    <FilePond
                        allowMultiple={true}
                        allowFileSizeValidation={true}
                        maxFileSize={'50MB'}
                        allowFileTypeValidation={true}
                        acceptedFileTypes={['image/*', 'audio/*', 'video/*', 'application/vnd.ms-excel',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                            'application/pdf']}
                        fileValidateTypeLabelExpectedTypes={'Supported types are image, audio, video, office documents, or pdf.'}
                        fileValidateTypeDetectType={(source, type) => new Promise((resolve, reject) => {
                            // Do custom type detection here and return with promise
                            return resolve(type);
                        })}
                        files={this.state.packingSlipFiles}
                        onupdatefiles={fileItems => {
                            this.setState({
                                packingSlipFiles: fileItems.map(fileItem => fileItem.file)
                            });
                        }}
                    />
                    <br/><br/>
                    {this.state.savingLog === true ?
                        <CircularProgress/>
                        :
                        <Button 
                            variant="contained"
                            color="primary"
                            className="success-button-lg"
                            onClick={this.addPurchaseOrder}
                        >
                            Save
                        </Button>
                    }
                    <br/><br/>
                </div>
            </WorkshopTemplate>
        );
    }
}

let globalProps;

export default Purchase;
